import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=432f0d64&"
import script from "./goods.vue?vue&type=script&lang=js&"
export * from "./goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports